
export enum LIMIT_DATE {
    EDATE = '2500-01-01',
    SDATE = '1900-01-01'
}


export enum OS {
    ANDROID,
    IOS,
    OTHERS
}
